<template>
  <div
    v-if="showAlert === true && alertItem !== undefined"
    :class="'rounded-md px-4 ' + alertItem.bgColor"
    class="w-full p-2"
  >
    <div class="flex h-full">
      <div class="flex-shrink-0">
        <font-awesome-icon
          size="lg"
          :class="'fatshrink-0 w-5 ' + alertItem.iconColor"
          aria-hidden="true"
          :icon="['fal', alertItem.icon]"
        />
      </div>
      <div class="ml-3 flex items-center">
        <h3
          v-if="title && title !== ''"
          :class="'!text-sm font-semibold ' + alertItem.titleColor"
          v-html="title"
        />
        <div :class="'!text-sm ' + alertItem.textColor">
          <slot></slot>
        </div>
      </div>
      <div v-if="dismissable" class="ml-auto">
        <div
          class="mt-0.5 flex h-5 w-5 cursor-pointer items-center justify-center rounded-md py-2"
          :class="alertItem.hoverColor"
          @click="emit('dismiss')"
        >
          <font-awesome-icon
            size="lg"
            class="h-3 w-3"
            :class="alertItem.iconColor"
            aria-hidden="true"
            :icon="['fas', 'xmark']"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IAlertComponent } from '@/interfaces/components/IAlertComponent'

const alertItem = ref<IAlertComponent>()

const {
  title,
  type = 'warning',
  showAlert = true,
  dismissable = false
} = defineProps<{
  title: string
  type?: string
  showAlert?: boolean
  dismissable?: boolean
}>()

const emit = defineEmits<{
  dismiss: []
}>()

onMounted(() => {
  getClasses(type)
})

const getClasses = (alertType: string) => {
  switch (alertType) {
    case 'warning': {
      alertItem.value = {
        bgColor: 'bg-yellow-50',
        iconColor: 'text-yellow-400',
        titleColor: 'text-yellow-800',
        textColor: 'text-yellow-700',
        icon: 'circle-exclamation',
        hoverColor: 'hover:bg-yellow-100'
      }
      break
    }
    case 'danger': {
      alertItem.value = {
        bgColor: 'bg-red-50',
        iconColor: 'text-red-400',
        titleColor: 'text-red-800',
        textColor: 'text-red-700',
        icon: 'xmark-circle',
        hoverColor: 'hover:bg-red-100'
      }
      break
    }
    case 'success': {
      alertItem.value = {
        bgColor: 'bg-green-50',
        iconColor: 'text-green-400',
        titleColor: 'text-green-800',
        textColor: 'text-green-700',
        icon: 'circle-check',
        hoverColor: 'hover:bg-green-100'
      }
      break
    }
    case 'info': {
      alertItem.value = {
        bgColor: 'bg-blue-50',
        iconColor: 'text-blue-400',
        titleColor: 'text-blue-800',
        textColor: 'text-blue-700',
        icon: 'circle-info',
        hoverColor: 'hover:bg-blue-100'
      }
      break
    }
    case 'gray': {
      alertItem.value = {
        bgColor: 'bg-gray-50',
        iconColor: 'text-gray-400',
        titleColor: 'text-gray-800',
        textColor: 'text-gray-700',
        icon: 'circle-info',
        hoverColor: 'hover:bg-gray-100'
      }
      break
    }
  }
}
</script>
